export function GanttFocusBanner({ line, onClear }) {
  return (
    <div className="px-4 py-2 bg-blue-50 border-b border-blue-100 flex items-center justify-between text-xs" data-testid="gantt-line-filter-banner">
      <span className="text-blue-800">Showing line <b>{line.line_code} · {line.name}</b> for the new order.</span>
      <button onClick={onClear} className="text-blue-600 hover:underline font-medium" data-testid="gantt-clear-line-filter">Show all lines</button>
    </div>
  );
}
